import { Box, FormControlLabel, Tooltip } from "@mui/material";
import { trim } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import {JobColor} from "../../../../../export/jobs";
import Highlight from "../../../../components/Highlight";
import FilterListCheckbox from "./filter-list-checkbox";

export const ListForFilter: React.FC<any> = ({ index, style, data }) => {
  const { items, isChecked, searchedValue, listWidth, applyFilter, hasAllRow } = data;
  const { t } = useTranslation();
  const selectedItem = items[index];
  // Options whose label is a translated string carry a language-neutral
  // `labelKey`; render that when present so the checkbox list stays localized,
  // otherwise fall back to the raw `name` (e.g. server-supplied values).
  const displayName = selectedItem.labelKey
    ? t(selectedItem.labelKey)
    : selectedItem.name;
  const textRef = useRef<HTMLSpanElement>(null);
  const [isEllipsed, setIsEllipsed] = useState(false);
  const isFirst = index === 0 && !hasAllRow;
  const isLast = index === items.length - 1;

  useEffect(() => {
    if (textRef.current) {
      setIsEllipsed(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, [displayName]);
  return (
    <div
      style={{
        ...style,
        paddingTop: isFirst ? "12px" : "0px",
        paddingBottom: isLast ? "12px" : "0px",
        width: `${listWidth}px`,
        overflowX: "hidden",
      }}
    >
      <FormControlLabel
        key={`filter-${selectedItem.id}`}
        sx={{
          width: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        control={
          <FilterListCheckbox
            checked={isChecked(selectedItem.id)}
            onChange={(e) => {
              applyFilter(selectedItem.id, e.target.checked);
            }}
          />
        }
        label={
          <Box display="flex" alignItems="center">
            {selectedItem.hexColor && (
              <JobColor color={`#${selectedItem.hexColor}`} />
            )}
            <Tooltip
              title={isEllipsed ? trim(displayName) : null}
              disableInteractive
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  fontSize: "14px",
                  marginLeft: selectedItem.hexColor ? "12px" : "2px",
                  fontFamily: "Roboto",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  maxWidth: `${
                    selectedItem.hexColor ? listWidth - 106 : listWidth - 80
                  }px`,
                  position: "relative",
                }}
              >
                <Box
                  ref={textRef}
                  component="span"
                  sx={{
                    display: "inline-block",
                    maxWidth: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    transition: "max-width 0.5s ease",
                  }}
                >
                  <Highlight
                    value={trim(displayName)}
                    searchText={searchedValue}
                  />
                </Box>
              </Box>
            </Tooltip>
          </Box>
        }
      />
    </div>
  );
};
